export enum ViewType {
  floorPlan = 'Floor Plan',
  unitPlan = 'Unit Plan',
  schedule = 'Schedule',
  plumbing = 'Plumbing',
  mechanical = 'Mechanical',
  lighting = 'Lighting',
  other = 'Other',
}

export function ViewTypeByString(value: string): ViewType {
  return Object.values(ViewType).find(enumValue => enumValue === value)!;
}